export default {"src":"/_next/static/media/Libkin.408eb882.svg","height":418,"width":418,"blurWidth":0,"blurHeight":0};